import React from 'react';

const SuccessStories = () => {
    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.title}>Student Success Stories</h1>
                <p style={styles.subtitle}>Real people. Real confidence. Real results.</p>
            </header>

            <div style={styles.grid}>
                <div style={styles.card}>
                    <p style={styles.quote}>"I used to be terrified of presentations. ARIVUNEST's method changed everything. I just got promoted!"</p>
                    <div style={styles.author}>- Rajesh K., Software Engineer</div>
                </div>
                <div style={styles.card}>
                    <p style={styles.quote}>"The grammar classes are not boring rules. They are logic tools. I finally understand *why* we say things."</p>
                    <div style={styles.author}>- Priya M., MBA Student</div>
                </div>
                <div style={styles.card}>
                    <p style={styles.quote}>"My IELTS score went from 6.0 to 8.5 in just 3 months. The specific training works wonders."</p>
                    <div style={styles.author}>- Ahmed S., Study Abroad Aspirant</div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: { maxWidth: '1200px', margin: '0 auto', padding: '60px 20px' },
    header: { textAlign: 'center', marginBottom: '60px' },
    title: { fontSize: '36px', color: '#2f3e46' },
    subtitle: { fontSize: '18px', color: '#666' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' },
    card: { padding: '30px', background: '#f8f9fa', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' },
    quote: { fontSize: '18px', fontStyle: 'italic', color: '#555', marginBottom: '20px' },
    author: { fontWeight: 'bold', color: '#27b05b' }
};

export default SuccessStories;
